import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useAssistantContext } from '../../providers';
import { useAssistantSelector } from '../../redux/assistant-hooks';
import { selectContextCompany, selectContextGrantApplication, selectHasContext, } from '../../redux/selectors';
import Doc from '@hellodarwin/icons/dist/icons/Doc';
import Enterprise from '@hellodarwin/icons/dist/icons/Enterprise';
import ContextBadge from './context-badge';
import { ContextIndicatorContainer } from './styles';
export const ContextIndicator = ({ onClearCompany, onClearGrantApplication, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const theme = useTheme();
    const { app } = usePlatform();
    const { usageContext } = useAssistantContext();
    const hasContext = useAssistantSelector(selectHasContext);
    const company = useAssistantSelector(selectContextCompany);
    const grantApplication = useAssistantSelector(selectContextGrantApplication);
    const isAdmin = app === 'admin';
    const hasVisibleContext = isAdmin
        ? hasContext
        : grantApplication.id && grantApplication.name;
    const companyId = (_a = company.id) !== null && _a !== void 0 ? _a : usageContext === null || usageContext === void 0 ? void 0 : usageContext.company_id;
    const grantApplicationId = (_b = grantApplication.id) !== null && _b !== void 0 ? _b : usageContext === null || usageContext === void 0 ? void 0 : usageContext.grant_application_id;
    const grantApplicationName = grantApplication.name || grantApplicationId;
    if (!hasVisibleContext) {
        return null;
    }
    return (_jsxs(ContextIndicatorContainer, { children: [isAdmin && companyId && company.name && (_jsx(ContextBadge, { icon: _jsx(Enterprise, { size: theme.spacing.md, color: theme.colors.purple_2 }), label: t('assistant|company'), value: company.name, href: `/companies/${companyId}`, onClear: onClearCompany, variant: "company" })), grantApplicationId && grantApplicationName && (_jsx(ContextBadge, { icon: _jsx(Doc, { size: theme.spacing.md, color: theme.colors.orange_1 }), label: t('assistant|grant_application'), value: grantApplicationName, href: grantApplication.programId
                    ? `/programs/${grantApplication.programId}`
                    : `/programs/${grantApplicationId}`, onClear: onClearGrantApplication, variant: "application" }))] }));
};
export default ContextIndicator;
